<template>
  <section id="login">
    <br>
    <div class="columns">
      <div class="column is-4">
      </div>
      <div class="column is-4">
        <div class="card">
          <!-- <header class="card-header"> -->
          <!-- </header> -->
          <div class="card-content">
            <p class="title has-text-centered">
              EFO Administratie Login
            </p>
            <div class="content">
              <b-field label="Gebruikersnaam">
                <b-input v-model="form.username"></b-input>
              </b-field>
              <b-field label="Watchwoord">
                <b-input v-model="form.password" type="password" password-reveal>
                </b-input>
              </b-field>
              <b-field grouped>
                <!-- Label left empty for spacing -->
                <p class="control">
                  <button class="button is-primary" @click="onSubmit">
                    Inloggen
                  </button>
                </p>
                <p class="control">
                  <button class="button">
                    Annuleren
                  </button>
                </p>
              </b-field>
            </div>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <span>
                <center>
                  <router-link to="/recover">Wachtwoord opvragen!</router-link>
                </center>

                <center>Voor het printen van OWKR click
                  <a href="http://rapportage.ministerie-owcs.cw:8082/jasperserver/login.html">
                    <b>
                      <u>hier.</u>
                    </b>
                  </a>
                </center>
                <center>Alleen toegangkelijk voor directeuren</center>
              </span>
            </p>
          </footer>
        </div>
      </div>
      <div class="column is-4">

      </div>
    </div>

  </section>
</template>
<script>
//import AppNavMD from './components/AppNavMD'
import Cookies from "js-cookie";

export default {
  name: "login",
  data() {
    return {
      form: {
        username: "",
        password: ""
      }
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    loggedin() {
      return this.$store.getters.getLoggedin;
    }
  },
  watch: {
    user: function(val) {
      var access = Cookies.get("access");
      var user = Cookies.getJSON("user");
      if (this.loggedin.success) {
        if (this.loggedin.data.tbl_sys_user.firstlogin) {
          this.$router.push({
            path: "/firstlogin/"
          });
        } else {
          if (this.loggedin.data.tbl_sys_user.locked_system) {
            this.$toast.open({
              message: "System is vergrendeld!",
              type: "is-danger"
            });
          } else {
            //this.$message.success(obj.msg);
            //redirect to editpage

            if (this.loggedin.data.tbl_sys_role.id == 4) {
              this.$router.push({
                path: "okrvoorzitter/"
              });
            } else if ((this.loggedin.data.tbl_sys_role.id == 5) || (this.loggedin.data.tbl_sys_role.id == 6)) {
              this.$router.push({
                path: "beroepresultaat/"
              });
            } else {
              this.$router.push({
                path: "okr/"
              });
            }
          }
        }
      } else {
        this.$toast.open({
          message: "Inloggen is mislukt!",
          type: "is-danger"
        });
      }
    }
  },
  methods: {
    Recover() {
      this.$router.push({
        path: "/recover"
      });
    },
    onSubmit() {
      console.log(this.form.username);
      console.log(this.form.password);
      console.log(this.form);
      this.$store.dispatch("login", {
        username: this.form.username,
        password: this.form.password
      });
    }
  }
};
</script>
